import { render } from "./iconELRCA.vue?vue&type=template&id=022b2c1b"
import script from "./iconELRCA.vue?vue&type=script&lang=js"
export * from "./iconELRCA.vue?vue&type=script&lang=js"
script.render = render

export default script